export default "__VITE_ASSET__Bh088Cc7__"